import { render, staticRenderFns } from "./ItemElementNewStatus.vue?vue&type=template&id=7949720c&scoped=true"
import script from "./ItemElementNewStatus.vue?vue&type=script&lang=ts"
export * from "./ItemElementNewStatus.vue?vue&type=script&lang=ts"
import style0 from "./ItemElementNewStatus.vue?vue&type=style&index=0&id=7949720c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7949720c",
  null
  
)

export default component.exports